const list = {
  path: 'alipay',
  component: resolve => require(['@/pages/admin/aftersales/alipay'], resolve)
}

export default list
